export enum ImportStatus {
  PENDING = 'pending',
  PARSED = 'parsed',
  MAPPING = 'mapping',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
  FAILED = 'failed',
}

export enum ImportFilter {
  ALL = 'all',
  ACTIVE_ONLY = 'active_only',
}

export type ImportSummary = {
  epicsCount: number;
  itemsCount: number;
  subitemsCount: number;
  usersCount: number;
};

export type FileColumn = {
  index: number;
  name: string;
  sampleValues: string[];
};

export type TaskonioField =
  | 'id'
  | 'taskName'
  | 'subitem'
  | 'epic'
  | 'status'
  | 'priority'
  | 'estimate'
  | 'storyPoints'
  | 'assignee'
  | 'startDate'
  | 'deadline'
  | 'description'
  | 'type'
  | 'labels';

export type PropertyMapping = {
  taskonioField: TaskonioField;
  fileColumnIndex: number | null;
  label: string;
  tooltip?: string;
  required: boolean;
};

export type UserMapping = {
  workspaceUserId: number;
  workspaceUserName: string;
  workspaceUserAvatar: string | null;
  fileUserName: string | null;
};

export type FileUser = {
  name: string;
  occurrences: number;
};

export type ImportRecord = {
  id: number;
  workspaceId: number;
  fileName: string;
  status: ImportStatus;
  importFilter: ImportFilter;
  propertyMappings: PropertyMapping[];
  userMappings: UserMapping[];
  addUnsortedToDescription: boolean;
  summary: ImportSummary;
  fileColumns: FileColumn[];
  fileUsers: FileUser[];
  createdBy: number;
  createdByUser: { id: number; fullName: string; profilePicturePath: string | null };
  createdAt: string;
  updatedAt: string;
  tasksCreatedCount?: number;
  labelsCreatedCount?: number;
  error?: string;
};

export type UpdateImportRequest = {
  importFilter?: ImportFilter;
  propertyMappings?: PropertyMapping[];
  userMappings?: UserMapping[];
  addUnsortedToDescription?: boolean;
  dateFormat?: string;
};
